import getConfig from 'config/public';
import { withG2BrandSegment } from 'shared-utils/g2Workspace';

export const ANCHOR_POSITION = {
  vertical: 'top',
  horizontal: 'right',
};

const G2_USER_WORKSPACE_URL = withG2BrandSegment(
  getConfig().userWorkspace.url,
  'getapp'
);

export const PROFILE_LINKS = {
  reviews: {
    group: 'workspace',
    label: 'Reviews',
    url: `${G2_USER_WORKSPACE_URL}?tab=my_reviews`,
    icon: ['far', 'comment'],
    event: {
      engagementComponent: 'header',
      engagementDestination: 'go-to_reviews',
      engagementDetails: 'button_reviews',
      eventName: 'engagement_navigation',
    },
  },
  rewards: {
    group: 'workspace',
    label: 'Rewards',
    url: `${G2_USER_WORKSPACE_URL}?tab=my_rewards`,
    icon: ['far', 'gem'],
    event: {
      engagementComponent: 'header',
      engagementDestination: 'go-to_rewards',
      engagementDetails: 'button_rewards',
      eventName: 'engagement_navigation',
    },
  },
  researchBoards: {
    group: 'workspace',
    label: 'Saved Products',
    url: `${G2_USER_WORKSPACE_URL}?tab=my_lists`,
    icon: ['far', 'heart'],
    event: {
      engagementComponent: 'header',
      engagementDestination: 'go-to_research-boards',
      engagementDetails: 'button_research-boards',
      eventName: 'engagement_navigation',
    },
  },
  profileDetails: {
    group: 'account',
    label: 'Profile Details',
    url: `${G2_USER_WORKSPACE_URL}?tab=profile_details`,
    icon: ['fal', 'user-circle'],
    event: {
      engagementComponent: 'header',
      engagementDestination: 'go-to_profile-details',
      engagementDetails: 'button_profile-details',
      eventName: 'engagement_navigation',
    },
  },
  settings: {
    group: 'account',
    label: 'Settings',
    url: `${G2_USER_WORKSPACE_URL}?tab=privacy_settings`,
    icon: ['far', 'cog'],
    event: {
      engagementComponent: 'header',
      engagementDestination: 'go-to_settings',
      engagementDetails: 'button_settings',
      eventName: 'engagement_navigation',
    },
  },
  signOut: {
    group: 'session',
    label: 'Sign Out',
    href: '/community/auth/logout',
    isSignOut: true,
    event: {
      engagementComponent: 'header',
      engagementDestination: 'sign-out',
      engagementDetails: 'button_sign-out',
      eventName: 'sign_out',
    },
  },
};

// Every profile item navigates on click, never through an href, so none of these
// URLs sit in the page markup for a crawler to follow. Sign out names the current
// page so G2's logout can send the visitor back to it.
export const getProfileLinkDestination = ({ url, href, isSignOut }) =>
  isSignOut
    ? `${href}?return_to=${encodeURIComponent(window.location.href)}`
    : url;

export default {
  ANCHOR_POSITION,
  PROFILE_LINKS,
};
